/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { GET_RECENT_EMAILS_SENT } from '../constants';

function cleanData(emails) {
  if (emails) {
    return emails
      .map(
        ({
          iD,
          status,
          emailName,
          sendTime,
          uniqueClicksPercentage,
          uniqueOpensPercentage,
          sent,
          delivered,
          targeted,
        }) => ({
          id: iD,
          status,
          emailName,
          sendTime: Date.parse(sendTime),
          uniqueClicksPercentage,
          uniqueOpensPercentage,
          sent,
          delivered,
          targeted,
        })
      )
      .slice(0, 5);
  }

  return emails;
}

let exampleState = [];
if (process.env.NODE_ENV !== 'production') {
  exampleState = cleanData([
    {
      longId: 8681,
      iD: '8681',
      mID: 7232606,
      status: 'Complete',
      sendID: 8681,
      emailID: 1192,
      emailName: 'University of Miami - Sample 02 - 030116',
      emailSubject: 'Email Subject',
      isMultipart: true,
      isTestSend: false,
      fromName: 'University of Miami',
      fromEmail: 'miami@reply.connect.miami.edu',
      bccEmail: '',
      businessUnitID: 7232606,
      trackingCategoryID: 2105,
      emailCategoryID: 0,
      sendTime: '2016-04-05T21:19:00',
      deliveredTime: '2016-04-05T21:20:00',
      modifiedDate: '2016-04-05T21:19:56.553',
      duplicates: 0,
      existingUndeliverables: 0,
      existingUnsubscribes: 0,
      hardBounces: 0,
      blockBounces: 0,
      technicalBounces: 0,
      unknownBounces: 0,
      softBounces: 0,
      otherBounces: 0,
      uniqueClicksPercentage: '0.00',
      uniqueOpensPercentage: '100.00',
      unsubscribesPercentage: '0.00',
      forwarded: 0,
      uniqueClicks: 0,
      totalClicks: 0,
      uniqueOpens: 1,
      totalOpens: 1,
      sent: 1,
      delivered: 1,
      targeted: 1,
      errored: 0,
      excluded: 0,
      unsubscribes: 0,
      totalBounces: 0,
      totalBouncesPercentage: '0.00',
    },
  ]);
}

export default function recentEmailsSent(state = exampleState, action) {
  switch (action.type) {
    case GET_RECENT_EMAILS_SENT: {
      let newState = state;

      if (action.error) {
        newState = [...state];
        newState.error = action.error;
      } else if (action.payload.response && action.payload.response.items) {
        newState = cleanData(action.payload.response.items);
      }

      return newState;
    }
    default: {
      return state;
    }
  }
}
